export class ProcedureDataModel {
    LabId: number;
    DoctorName: string;
    File_Name: string;
    HospitalNo: string;
    Instructions: string;
    RequestDate: string;
    LabsSubData: ProcedureViewModel[];
}
export class ProcedureViewModel {
    LabId: number;
    ReqNo: string;
    Req_Detail_No: string;
    Status: string;
    TestCode: string;
    TestName: string;
    Instructions: string;
    Result_Available: string;
    View_Report: string;
    Instructions_Available: string;
    strRadiologyTestReport: string;
    REPORT_NO: string;
    DIAGNOSIS: string; 
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/Procedure/ProcedureDataModel.ts